import type { DeliveryProcessApi } from '@ipen-portal/backstage-plugin-delivery-process-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const deliveryProcessApiRef = createApiRef<
  TRPCOptionsProxy<DeliveryProcessApi>
>().with({
  id: 'plugin.ipen.delivery-process.api',
});
